import { ClockIcon, TagIcon, UserIcon } from "@phosphor-icons/react";
import { RefObject } from "react";

interface FormHeaderProps {
	icon: string;
	title: string;
	description: string;
	headingRef: React.LegacyRef<HTMLHeadingElement>;
}

export function FormHeader({ icon, title, description, headingRef }: FormHeaderProps) {
	return (
		<div className="jF-flex jF-flex-row jF-gap-2 jF-items-center">
			<div
				ref={headingRef}
				className="jF-w-12 jF-h-12 jF-flex jF-items-center jF-justify-center jF-rounded-lg jF-bg-[--jF-theme-color]"
			>
				{icon === "clock" && (
					<ClockIcon
						className="jF-p-1 jF-h-10 jF-w-10 jF-text-white"
						aria-hidden="true"
					/>
				)}
				{icon === "tag" && (
					<TagIcon className="jF-p-1 jF-h-10 jF-w-10 jF-text-white" aria-hidden="true" />
				)}
				{icon === "user" && (
					<UserIcon className="jF-p-1 jF-h-10 jF-w-10 jF-text-white" aria-hidden="true" />
				)}
			</div>
			<div className="jF-flex jF-flex-col">
				<h1 className="jF-text-lg jF-font-bold jF-mb-0">{title}</h1>
				<p className="jF-text-sm jF-text-gray-500">{description}</p>
			</div>
		</div>
	);
}
